// extracted by mini-css-extract-plugin
module.exports = {"fade":"Animation_fade__17rz5","fadeOn":"Animation_fadeOn__EFfKK","fadeOn3":"Animation_fadeOn3__1X7cq","fadeOn6":"Animation_fadeOn6__3QyHK"};